export default "__VITE_ASSET__wsZf8_o1__"